import PropTypes from 'prop-types';
import Translation from '../../lang/Translation';
import useStyles from './DetailedTooltip.styles';

function DetailedTooltip(props) {
  const classes = useStyles();
  return (
    <div id={`tooltip-content--${props.tooltipID}`} aria-hidden="true" className={classes.DetailedTooltip}>
      {props.title && (
        <div data-test="detailed-tooltip-title" className={classes.DetailedTooltipTitle}>
          <Translation>{props.title}</Translation>
        </div>
      )}
      {props.children}
    </div>
  );
}

DetailedTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  tooltipID: PropTypes.string,
};

DetailedTooltip.defaultProps = {
  title: null,
};

export default DetailedTooltip;
